import React from "react";
import { BadgeCheck, CalendarClock, TrendingUp, Wifi } from "lucide-react";
import "./why-us.css";

const features = [
  {
    Icon: BadgeCheck,
    title: "Sertifikovan trener",
    desc: "Mihailo je sertifikovan fitnes trener sa višegodišnjim iskustvom u radu sa klijentima svih nivoa.",
  },
  {
    Icon: Wifi,
    title: "100% online",
    desc: "Treninzi i konsultacije dostupni su online — iz udobnosti tvog doma, u bilo koje vreme.",
  },
  {
    Icon: CalendarClock,
    title: "Fleksibilni termini",
    desc: "Jutarnji, popodnevni ili večernji termini — prilagođavamo se tvom rasporedu.",
  },
  {
    Icon: TrendingUp,
    title: "Praćenje napretka",
    desc: "Redovan feedback i izveštaji kako bi uvek znao gde si i šta sledeće radiš.",
  },
];

export default function WhyUs() {
  return (
    <section className="why-section">
      <div className="why-inner">
        <div className="why-left">
          <div className="why-eyebrow">Zašto Mihailo</div>
          <h2 className="why-title">TRENINZI KOJI ZAISTA DAJU REZULTATE</h2>
          <p className="why-sub">
            Naši treneri ne samo da znaju kako se vežba — znaju i kako se uči. Svaki
            trening je prilagođen tvom nivou, ciljevima i tempu, sa pravim razgovorom
            od prvog časa.
          </p>
          <a href="/kontakt/" className="why-cta">Zakaži besplatne konsultacije</a>
        </div>

        <div className="why-right">
          {features.map(({ Icon, ...f }, i) => (
            <div className="why-feature" key={i}>
              <div className="why-feature-icon">
                <Icon size={19} strokeWidth={2.2} />
              </div>
              <div>
                <h4 className="why-feature-title">{f.title}</h4>
                <p className="why-feature-desc">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
